"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const constants_1 = require("./constants");
const util_1 = require("util");
const localStorage_1 = require("./localStorage");
const redux_1 = require("redux");
const react_router_redux_1 = require("react-router-redux");
const react_router_1 = require("react-router");
const reducer_1 = require("./reducer");
// TODO: Remove after the sprint release
const AuthenticationActions_1 = require("./authentication/AuthenticationActions");
const middleware = redux_1.applyMiddleware(react_router_redux_1.routerMiddleware(react_router_1.browserHistory));
let enhancers;
if (process.env.NODE_ENV === "production") {
    enhancers = redux_1.compose(middleware);
} else {
    if (util_1.isNullOrUndefined(window.devToolsExtension)) {
        enhancers = redux_1.compose(middleware);
    } else {
        enhancers = redux_1.compose(middleware, window.devToolsExtension());
    }
}
let persistedState = constants_1.INITIAL_STATE;
persistedState.authentication = localStorage_1.loadState() || constants_1.INITIAL_STATE.authentication;
const store = redux_1.createStore(reducer_1.default, persistedState, enhancers);
store.subscribe(lodash_1.throttle(() => {
    // TODO: Remove after the sprint release
    const authentication = store.getState().authentication;
    if (authentication && authentication.accessToken && (!authentication.organization || authentication.organization && authentication.organization.marker)) {
        store.dispatch(AuthenticationActions_1.updateOrganizationByAccessToken());
    }
    localStorage_1.saveState(authentication);
    // Replace with saveState((<ApplicationStore>store.getState()).authentication);
}, 1000));
exports.history = react_router_redux_1.syncHistoryWithStore(react_router_1.browserHistory, store);
exports.default = store;


//////////////////
// WEBPACK FOOTER
// ./client/src/store.ts
// module id = 574
// module chunks = 0 1 2